// 瑞典语
export const GUIDES = [
  { name: 'guide-overview', title: 'Översikt över funktioner', groupIndex: 0 },
  { name: 'guide-account', title: 'Om kontot', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Om fordonet', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Hur du ställer in instrumentpanelen', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Hur du ställer in fordonet', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Hur man navigerar för att hitta fordonet', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Hur man använder navigeringen', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Om resehistorik', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Så här utför du en egenkontroll av fordonet', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Hur man gör allmänna inställningar för APP', groupIndex: 3 },
  { name: 'guide-notice', title: 'Hur man visar och ställer in meddelandeavisering', groupIndex: 3 },
  { name: 'guide-about', title: 'Om APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'I väntan på',
  1: 'Inget svar',
  2: 'Svarat',
  3: 'i kommunikation',
  4: 'motåtgärder',
  5: 'löst',
};

export const FEEDBACK_TYPES = {
  1: 'Återkoppling',
  2: 'Svara',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
